import { Schema as S } from "effect";
import { PatientDataSchema } from "../get-patient-from-card/get-patient-from-card.response";

export const GetPatientFromTerminalResponseSchema = S.Struct({
  patients: S.Array(S.toType(PatientDataSchema)),
  status: S.Union(
    [S.Literal("no-patient-cards"),
    /** An eGK is inserted, but inSuite returned no patient payload for it. */
    S.Literal("patient-card-unreadable"),
    S.Literal("patient-card-found"),
    S.Literal("no-practitioner-cards"),
    S.Literal("no-card-selected")],
  ),
});

export type GetPatientFromTerminalResponse = S.Schema.Type<typeof GetPatientFromTerminalResponseSchema>;
